<mat-form-field>
  <mat-label>Arbetsgivarens namn</mat-label>
  <input #input="ngModel" [(ngModel)]="model" matInput maxlength="50" required>

  @if (input.errors) {
    <mat-error>Vänligen kontrollera fältet</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }
</mat-form-field>
